<div class="container">
  <ngo-spinner-icon [isLoading]="(loaded$ | async) !== true" [size]="'medium'"></ngo-spinner-icon>
</div>

<ng-template class="entity-document-tree-list" [ngIf]="items && items.length > 0">
  <ngx-treeview [items]="items" [config]="config" [itemTemplate]="itemTemplate">
  </ngx-treeview>
</ng-template>

<ng-template #itemTemplate let-item="item">
  <div class="row-item clickable" [class.year-node]="item.isYearNode">
    <span class="icon">
      <span *ngIf="item.hasChildren" (click)="expandNode(item);">
        <span *ngIf="item.collapsed !== true">
          <fa-icon [icon]="['fal', 'minus-square']" [styles]="{'margin-right': '5px', 'cursor': 'pointer'}"></fa-icon>
        </span>
        <span *ngIf="item.collapsed">
          <fa-icon [icon]="['fal', 'plus-square']" [styles]="{'margin-right': '5px', 'cursor': 'pointer'}"></fa-icon>
        </span>
      </span>
    </span>
    <span *ngIf="item.isYearNode" class="tree-item-label year-label">{{ item.text }}</span>
    <span *ngIf="!item.isYearNode && !item.url" class="tree-item-label">{{ item.text }}</span>
    <a *ngIf="!item.isYearNode && item.url" class="tree-item-label" [href]="item.url" target="_blank" rel="noopener noreferrer">
      {{ item.text }}
    </a>
  </div>
</ng-template>